module.exports = __webpack_public_path__ + "img/wuyazai.d304795b.png";